module.exports = __webpack_public_path__ + "img/start.9e25af7c.svg";